import { render } from "./ZonePink.vue?vue&type=template&id=4a23bbb6&scoped=true"
import script from "./ZonePink.vue?vue&type=script&lang=js"
export * from "./ZonePink.vue?vue&type=script&lang=js"

import "./ZonePink.vue?vue&type=style&index=0&id=4a23bbb6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a23bbb6"]])

export default __exports__